export const useFileUrl = (file?: File) => {
  if (!file) return '#'
  const blob = new Blob([file], { type: file.type })
  return URL.createObjectURL(blob)
}
